// ============================================================
//  MASAMADREAM — UI helpers
// ============================================================

/**
 * Show a named screen, hiding all others.
 * @param {'home' | 'dashboard'} name
 */
export function showScreen(name) {
  document.querySelectorAll('.mm-screen').forEach(el => {
    el.classList.remove('is-active');
  });
  const target = document.getElementById(`mm-screen-${name}`);
  if (target) target.classList.add('is-active');
}

/**
 * Set text content safely.
 */
export function setText(id, value) {
  const el = document.getElementById(id);
  if (el) el.textContent = value;
}

/**
 * Toggle mm-hidden class.
 */
export function setVisible(id, visible) {
  const el = document.getElementById(id);
  if (!el) return;
  if (visible) {
    el.classList.remove('mm-hidden');
  } else {
    el.classList.add('mm-hidden');
  }
}

/**
 * Format milliseconds → HH:MM:SS
 */
export function formatCountdown(ms) {
  if (ms === null || ms === undefined) return '--:--:--';
  if (ms <= 0) return '¡Ahora!';
  const totalSecs = Math.floor(ms / 1000);
  const h = Math.floor(totalSecs / 3600);
  const m = Math.floor((totalSecs % 3600) / 60);
  const s = totalSecs % 60;
  return [h, m, s].map(n => String(n).padStart(2, '0')).join(':');
}
